module.exports = __webpack_public_path__ + "res/12-img_game_text.13b3977e868e6f4d3352211036895dbd.png";